'use client'

import dynamic from 'next/dynamic'

// A client boundary is required for code splitting. A server-only dynamic
// import still includes these players in every article's client entry.
export const AudioFileLazy = dynamic(() => import('./audio-file').then((m) => m.AudioFileClient))
